import _ from 'lodash';

import { talentProfiles } from '../data/talentProfiles';

import {
  getDimensionsForCategory
} from '../util';

import {
  DIMENSION_CATEGORY_IDS
} from './data';

export const scoreAssessmentForExport = (responses, assessmentVersion, talentProfileId, scoringAlgoVersion) => {

  try{

    const assessmentQuestions = assessmentVersion.questions;

    const coreProfileId = talentProfiles[talentProfileId].coreProfileId;
    const configForThisTalentProfile = talentProfiles[talentProfileId];
    const coreConfigForThisTalentProfile = talentProfiles[coreProfileId];

    let fitScore = 0;
    let fitItems = 0;
    let fitTotalPossible = 0;


    let profileDimensionScores = {};
    _.each(configForThisTalentProfile.scoredDimensions, dimensionId => {
      profileDimensionScores[dimensionId] = {
        total: 0,
        count: 0,
        avg: 0,
        adjusted: 0
      }
    });

    //iterate through each response and score responses that are not experimental to all dimensions that
    //response is scored for
    _.each(responses, (response, questionId) => {
      const questionForResponse = assessmentQuestions[questionId];

      //if experimental question...don't score
      if(questionForResponse.experimentId){
        return;
      }
      else if(questionForResponse.questionFormat !== 'likert'){
        //only score likert for now...
        return;
      }
      else{
        //will score...
        const reverseScore = questionForResponse.reverseScore;

        //assessment v1 had incorrect scoring of 7 - response instead of 8 - response for reversed questions
        //need to preserve this for consistency
        let scoredResponseValue;
        if(scoringAlgoVersion && scoringAlgoVersion === '1'){
          scoredResponseValue = (reverseScore ? (7 - response) : response);
        }
        else{
          //Latest version
          scoredResponseValue = (reverseScore ? (8 - response) : response);
        }

        //score for dimension
        _.each(Object.keys(questionForResponse.scoredDimensions), dimensionToScore => {

          //if dimension to score is associated with talent profile...track the dimension score
          if(configForThisTalentProfile.scoredDimensions.indexOf(dimensionToScore) !== -1){
            profileDimensionScores[dimensionToScore].total += scoredResponseValue;
            profileDimensionScores[dimensionToScore].count += 1;
          }
        });

        //if question is predictive for talent profile, add to fit score
        if(questionForResponse.predictiveIndexes[coreProfileId]){
          fitScore += scoredResponseValue;
          fitItems += 1;
          fitTotalPossible += 7;
        }
      }


    });

    //after going through all responses for this profile, calculate averages
    for(const dimensionKey in profileDimensionScores){
      const profileDimension = profileDimensionScores[dimensionKey];
      const totalForProfileDimension = profileDimension.total;
      const countForProfileDimension = profileDimension.count;
      const avg = totalForProfileDimension / countForProfileDimension;

      profileDimension.avg = avg;
      profileDimension.adjusted = Math.round(avg * 1400)/100;
    }

    console.log('profileDimensionScores: ', profileDimensionScores);

    let categoryScores = {};
    let totalScoreForUser = 0;
    let adjustedTotalScoreForUser = 0;
    const scaleVarianceFactor = 2.5;

    //now score categories
    _.each(DIMENSION_CATEGORY_IDS, function(dimensionCategoryId){

      categoryScores[dimensionCategoryId] = {};
      categoryScores[dimensionCategoryId]['dimensions'] = {};

      let dimensionCategoryTotal = 0;
      let adjustedDimensionCategoryTotal = 0;

      const dimensionCategoryScoredComponents = getDimensionsForCategory(configForThisTalentProfile.scoredDimensions, dimensionCategoryId);

      // console.log('dimensionCategoryScoredComponents: ', dimensionCategoryScoredComponents);

      //go through each component and add to talent category total + set "raw" score value
      _.each(dimensionCategoryScoredComponents, function(dimensionId){

        // console.log('getting score for dimensionId: ', dimensionId);

        categoryScores[dimensionCategoryId]['dimensions'][dimensionId] = {};
        const scoreForDimension = (profileDimensionScores[dimensionId] || {})['avg'] || 0;

        // console.log('scoreForDimension: ', scoreForDimension);

        const adjustedScoreForDimension = Math.pow(scoreForDimension, scaleVarianceFactor);

        dimensionCategoryTotal += scoreForDimension;
        adjustedDimensionCategoryTotal += adjustedScoreForDimension;
        categoryScores[dimensionCategoryId]['dimensions'][dimensionId]['avg'] = scoreForDimension;
        categoryScores[dimensionCategoryId]['dimensions'][dimensionId]['adjusted'] = adjustedScoreForDimension;
      });

      //iterate through again now that we have total to compute percentages
      //also add dimension id
      _.each(dimensionCategoryScoredComponents, dimensionId => {
        categoryScores[dimensionCategoryId]['dimensions'][dimensionId]['id'] = dimensionId;
        categoryScores[dimensionCategoryId]['dimensions'][dimensionId]['percent'] = categoryScores[dimensionCategoryId]['dimensions'][dimensionId]['adjusted'] * 100 / adjustedDimensionCategoryTotal;
      });

      const dimensionCategoryAverage = dimensionCategoryTotal / dimensionCategoryScoredComponents.length;
      const adjustedDimensionCategoryAverage = adjustedDimensionCategoryTotal / dimensionCategoryScoredComponents.length;

      categoryScores[dimensionCategoryId]['raw'] = dimensionCategoryAverage;
      categoryScores[dimensionCategoryId]['adjusted'] = adjustedDimensionCategoryAverage;

      totalScoreForUser += dimensionCategoryAverage;
      adjustedTotalScoreForUser += adjustedDimensionCategoryAverage;
    });

    _.each(DIMENSION_CATEGORY_IDS, function(dimensionCategoryId){
      categoryScores[dimensionCategoryId]['id'] = dimensionCategoryId;
      categoryScores[dimensionCategoryId]['percent_raw'] = categoryScores[dimensionCategoryId]['raw'] * 100 / totalScoreForUser;
      categoryScores[dimensionCategoryId]['percent'] = categoryScores[dimensionCategoryId]['adjusted'] * 100 / adjustedTotalScoreForUser;
    });

    return {
      fitData: {
        score: fitScore,
        items: fitItems,
        totalPossible: fitTotalPossible
      },
      profileDimensionScores,
      categoryScores,
    };
  }
  catch(err){
    console.error('Error during assesment scoring for profile: ', err);
    throw err;
  }
}



// WEBPACK FOOTER //
// ./src/util/assessmentScoring.js